
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.455 20.601"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-108.655 -813.514)","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M124.5 821.653h-15.231a.114.114 0 00-.114.114v2.82a.114.114 0 00.114.114h.833v8.438a.476.476 0 00.477.476h12.671a.477.477 0 00.477-.476v-8.438h.769a.114.114 0 00.114-.114v-2.82a.114.114 0 00-.11-.114zM116.775 821.292s-10.158-2.515-5.966-6.434c4.025-3.758 5.966 6.434 5.966 6.434zM116.989 821.292s10.158-2.515 5.965-6.434c-4.025-3.758-5.965 6.434-5.965 6.434z"}}),_c('line',{attrs:{"x2":"13.199","transform":"translate(110.103 824.701)"}}),_c('line',{attrs:{"y2":"12.323","transform":"translate(116.882 821.292)"}})])])
          )
        }
      }
    